import React from "react";
import { FileIcon } from "./icons";
import { ReactComponent as FolderIcon } from "../../assets/svgs/zed/file/folder.svg";
import { ReactComponent as FolderOpenIcon } from "../../assets/svgs/zed/file/folder_open.svg";

// The project panel: the repository's folders and files, folders first, with a guide down each
// open folder. Ignored folders (build, node_modules) are dimmed. A click opens a folder or previews
// a file; a double-click keeps the file open.
const Node = ({ node, path, depth, open, selected, onToggle, onOpen }) => {
  const isOpen = node.dir && open.has(path);
  const Icon = node.dir ? (isOpen ? FolderOpenIcon : FolderIcon) : FileIcon;
  return (
    <li role="treeitem" aria-expanded={node.dir ? isOpen : undefined} aria-selected={path === selected}>
      <button
        type="button"
        className={`zd-row ${path === selected ? "is-selected" : ""} ${node.ignored ? "is-ignored" : ""}`}
        style={{ "--depth": depth }}
        onClick={() => (node.dir ? onToggle(path) : onOpen(path, true))}
        onDoubleClick={() => !node.dir && onOpen(path, false)}
      >
        <Icon className="zd-row-icon" name={node.name} aria-hidden="true" />
        <span className="zd-row-name">{node.name}</span>
      </button>
      {isOpen && node.children.length > 0 && (
        <ul role="group" className="zd-tree-group" style={{ "--depth": depth }}>
          {node.children.map((child) => (
            <Node
              key={child.name}
              node={child}
              path={`${path}/${child.name}`}
              depth={depth + 1}
              open={open}
              selected={selected}
              onToggle={onToggle}
              onOpen={onOpen}
            />
          ))}
        </ul>
      )}
    </li>
  );
};

const ProjectPanel = ({ tree, open, selected, onToggle, onOpen }) => (
  <nav className="zd-project no-select" aria-label="Project">
    {tree ? (
      <ul role="tree" className="zd-tree">
        <Node
          node={tree}
          path={tree.name}
          depth={0}
          open={open}
          selected={selected}
          onToggle={onToggle}
          onOpen={onOpen}
        />
      </ul>
    ) : (
      <p className="zd-empty">Loading…</p>
    )}
  </nav>
);

export default ProjectPanel;
